import { createContext, useContext, useState } from "react";

export const UIContext = createContext();

export const useUI = () => useContext(UIContext);

export const UIProvider = ({ children }) => {
  const [isActionLocked, setIsActionLocked] = useState(false);

  return (
    <UIContext.Provider value={{ isActionLocked, setIsActionLocked }}>
      {children}
    </UIContext.Provider>
  );
};
